export class BadEntityError {
    public readonly errors: any;

    constructor(errors: any) {
        this.errors = errors;
    }
}